import { IAdvertisement } from '@app/common';
import { crudEndpoints } from '../crud-endpoints.factory';
import { rootApi } from '../api';

const url = 'advertisements';
const tagType = 'Advertisements';

export const advertisementApi = rootApi.injectEndpoints({
  endpoints: (builder) => {
    const endpoints = crudEndpoints<IAdvertisement>(builder, url, tagType);

    return {
      createOneAdvertisement: builder.mutation<IAdvertisement, FormData>({
        invalidatesTags: [{ type: tagType, id: 'LIST' }],
        query: (body) => ({
          url,
          method: 'POST',
          body,
        }),
      }),
      updateOneAdvertisement: builder.mutation<
        Partial<IAdvertisement>,
        { _id: string; formData: FormData }
      >({
        invalidatesTags: (_, __, arg) => [{ type: tagType, id: arg._id }],
        query: ({ _id, formData }) => ({
          url: `${url}/${_id}`,
          method: 'PUT',
          body: formData,
        }),
      }),
      readManyAdvertisements: endpoints.readMany(),
      readOneAdvertisement: endpoints.readOne(),
      deleteOneAdvertisement: endpoints.deleteOne(),
    };
  },
});
